module.exports = __webpack_public_path__ + "img/H20.f5316eed.png";